module.exports = InternalShared('InternalShared/PageBuilder/Controls/Core/Generators/PDFControlGenerator');